export interface EventDateEntry {
  start: string;
  date: string;
}

const MONTH_INDEX_BY_TOKEN: Partial<Record<string, number>> = {
  jan: 0,
  january: 0,
  feb: 1,
  february: 1,
  mar: 2,
  march: 2,
  apr: 3,
  april: 3,
  may: 4,
  jun: 5,
  june: 5,
  jul: 6,
  july: 6,
  aug: 7,
  august: 7,
  sep: 8,
  sept: 8,
  september: 8,
  oct: 9,
  october: 9,
  nov: 10,
  november: 10,
  dec: 11,
  december: 11,
};

export const parseEventStartDate = (start: string, dateLabel: string): Date | null => {
  const isoDate = /^(\d{4})-(\d{2})-(\d{2})$/.exec(start);
  if (isoDate) {
    const isoDateValue = new Date(`${start}T00:00:00Z`);
    return Number.isNaN(isoDateValue.getTime()) ? null : isoDateValue;
  }

  const monthDayMatch = /^([A-Za-z.]+)\s+(\d{1,2})$/.exec(start);
  if (!monthDayMatch) {
    return null;
  }

  const [, rawMonth, rawDay] = monthDayMatch;
  const normalizedMonth = rawMonth.toLowerCase().replace(/\./g, "");
  const monthIndex = MONTH_INDEX_BY_TOKEN[normalizedMonth];
  if (monthIndex == null) {
    return null;
  }

  const yearMatch = /(\d{4})/.exec(dateLabel);
  const year = Number(yearMatch?.[1]);
  const day = Number(rawDay);
  if (Number.isNaN(year) || Number.isNaN(day)) {
    return null;
  }

  const normalizedDate = new Date(Date.UTC(year, monthIndex, day, 0, 0, 0));
  return Number.isNaN(normalizedDate.getTime()) ? null : normalizedDate;
};

const isUpcomingEvent = (event: EventDateEntry, referenceDate: Date) => {
  const startDate = parseEventStartDate(event.start, event.date);
  return startDate != null && startDate.getTime() >= referenceDate.getTime();
};

export const splitEventsByDate = <T extends EventDateEntry>(
  events: T[],
  referenceDate: Date = new Date(),
) => {
  const upcomingEvents = events.filter((event) => isUpcomingEvent(event, referenceDate));
  const pastEvents = events.filter((event) => !isUpcomingEvent(event, referenceDate));

  return { upcomingEvents, pastEvents };
};
